import { iconSize, IconSizeProps } from '@/types/icons';

export const IconSendPlane = ({ size }: IconSizeProps) => {
  return (
    <svg
      fill="currentColor"
      className={iconSize[size]}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <path d="M19.3286 3.68294C20.1195 3.40615 20.8796 4.16633 20.6028 4.95715L15.1222 20.6161C14.823 21.4709 13.6324 21.5195 13.2645 20.6919L10.4452 14.3483C10.3446 14.1221 10.1637 13.9412 9.93749 13.8406L3.59389 11.0212C2.76627 10.6534 2.81484 9.46277 3.66968 9.16357L19.3286 3.68294Z" />
      <path
        d="M15.8536 9.35038C16.0488 9.15512 16.0488 8.83853 15.8536 8.64327C15.6583 8.44801 15.3417 8.44801 15.1464 8.64327L15.8536 9.35038ZM9.35355 15.8504L15.8536 9.35038L15.1464 8.64327L8.64645 15.1433L9.35355 15.8504Z"
        fill="white"
      />
    </svg>
  );
};
